<template>
  <div class="p-2 rounded-l-lg" :class="isActive ? 'bg-black/35' : ''">
    <IonMenuToggle>
      <button class="appearance-none w-full text-left text-xl pl-1" @click.self="onLinkClick()">
        <i :class="icon" class="mr-2"></i>
        {{ text }}
      </button>
    </IonMenuToggle>
  </div>
</template>

<script setup lang="ts">
import { IonMenuToggle, useIonRouter } from '@ionic/vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    icon: string;
    text: string;
    path: string;
    isExternal?: boolean;
  }>(),
  {
    isExternal: false,
  }
);

const router = useIonRouter();
const route = useRoute();

const isActive = computed(() => route.path === props.path);

function onLinkClick() {
  if (props.isExternal) {
    window.open(props.path, '_blank');
    return;
  } else {
    router.push(props.path);
  }
}
</script>

<style scoped></style>
